<form #form="ngForm" (ngSubmit)="save(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Employee ID-->
    <div class="p-field p-col-12 p-md-6">
      <span class="p-float-label">
        <input pInputText 
               required
               id="roleName" name="roleName"
               class="p-inputtext-sm"
               #roleName="ngModel"
               [(ngModel)]="role.roleName" 
               [class.field-error]="form.submitted && roleName.invalid"/>
        <label for="roleName">Role Name</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && roleName.invalid">Role name is required</small>
    </div>
  </div> 

  <!-- Row 2 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--Note -->
    <div class="p-field p-col-12 p-md-12">
      <span class="p-float-label">
        <textarea pInputTextarea
                  id="roleDescription"
                  name="roleDescription"
                  class="p-inputtext-sm"
                  rows="5"
                  [(ngModel)]="role.roleDescription"></textarea>
        <label for="roleDescription">Role Description</label>
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
